define('casino/allgames',['jquery', 'casino/casino', 'casino/casino-data', 'casino/populate', 'all/template'], function ($, casino, casinoData) {
		'use strict';

		var allResults = {};
		var combinedResults = [];
		var currentCount = 0;
		var filterClickedFromStartPage = false;
		var isNecessaryToReloadLobbyAfterHashChanged = true;

		var $casinoAllgames = $('#casino-allgames');
		var $filterProviders = $casinoAllgames.find('#filter-providers');
		var $playtechGameProvider = $casinoAllgames.find('#playtech');

		function applySelectedSortOrder(gameIds, $main) {
			var $sortClicked = $main.find('#sort-games a.active');
			var order = $sortClicked.data('order');

			var sortedResults = [];
			for (var i = 0; i < order.length; i++) {
				var orderedGame = String(order[i]);

				if (gameIds.indexOf(orderedGame) !== -1) {
					sortedResults.push(order[i]);
				}

				// this part is support for a single game in a group, for instance inside a game bundle
				if (orderedGame.slice(0, 5) === 'group') {
					var group = casino.getGame(orderedGame);

					var groupGames = Object.keys(group.games);
					for (var j = 0; j < groupGames.length; j++) {
						if (gameIds.indexOf(groupGames[j].slice(5)) !== -1) {
							sortedResults.push(groupGames[j].slice(5));
						}
					}
				}
			}

			$main.find('#rightcolumn h1:first').applyTemplate({count: sortedResults.length, total: Object.keys(casinoData.games).length});
			currentCount = sortedResults.length;
			return sortedResults;
		}

		// matching cross-section of the filters selected
		function combineAllFilters($main) {

			var noOfFilterGroups = Object.keys(allResults).length;

			if (noOfFilterGroups === 0) {
				combinedResults = $main.find('#sort-games a.active').data('order');
			} else {
				var joinedResults = {};
				$.each(allResults, function (undefined, gameIds) {
					for (var i = 0; i < gameIds.length; i++) {
						if (isNaN(joinedResults[gameIds[i]])) {
							joinedResults[gameIds[i]] = 1;
						} else {
							joinedResults[gameIds[i]]++;
						}
					}
				});

				// here's some magic: display only those who are in all groups, which means they have a count of the same as active groups
				combinedResults = $.grep(Object.keys(joinedResults), function (key) {
					return joinedResults[key] === noOfFilterGroups;
				});
			}
			return combinedResults;
		}

		function calculateFilterGroup($container) {
			var joinedResults = {};

			var $actives = $container.find('li.active');

			var template = 'default';
			if ($actives.length === 1) {
				template = 'singular';
			} else if ($actives.length > 1) {
				template = 'plural';
			}

			$container.find('p').first().applyTemplate({count: $actives.length}, {template: template});
			currentCount = $actives.length;

			$actives.each(function () {
				var $t = $(this);
				var gameIds = $t.data('games');
				for (var i = 0; i < gameIds.length; i++) {
					joinedResults[gameIds[i]] = true;
				}
			});

			var id = $container.attr('id');
			var keys = Object.keys(joinedResults);
			if (keys.length > 0) {
				allResults[id] = keys;
			} else {
				delete allResults[id];
			}
		}

		// these link directly into the all games page with one filter selected
		function setupStartLinks($main) {
			$('#casino-start').find('#categories li').each(function (index) {
				var $li = $(this);
				$li.on('click', function () {
					var $a = $(this).find('a');
					location.href = $a.attr('href');
					clickShowAll($main);
					$main.find('li').eq(index).trigger('click');
					filterClickedFromStartPage = true;
				});
			});
		}


		function setupShowAll($filters, $main, options) {
			$filters.find('a:first').on('click', function () {
				var $a = $(this);
				var $container = $a.parents('.cnt-filter');
				//there is no need to click show all if none of the providers/categories is not selected in the respective section
				if (!$container.hasClass('active')) {
					return;
				}
				$container.removeClass('active');
				$container.find('li').removeClass('active');
				calculateFilterGroup($container);
				update($main, options);
				var id = $(this).parent().attr('id');
				if (id === 'filter-providers' && checkIfWeAreOnTheAllGamesPage()) {
					//var providers = getGameProvidersExtractedFromHash();
					updateGameProviders([]);
				}
			});
		}

		function setupFilters($filters, $main, options) {
			$filters.find('li').on('click', function () {
				var $li = $(this);

				$li.toggleClass('active');

				var $container = $li.parents('.cnt-filter');

				var $activeFilters = $container.find('li.active');
				if ($activeFilters.length > 0) {
					$container.addClass('active');
				} else {
					$container.removeClass('active');
				}
				calculateFilterGroup($container);
				update($main, options);

				if($container.attr('id') === 'filter-providers') {
					var providers = [];
					$.each($activeFilters, function() {
						providers.push($(this).attr('id'));
					});
					updateGameProviders(providers);
				}
			});
		}

		function setupSort($main, options) {
			var $links = $main.find('#sort-games a');
			$links.each(function () {
				$(this).on('click', function () {
					var $link = $(this);
					if ($link.hasClass('active')) {
						return;
					}
					$link.siblings().removeClass('active');
					$link.addClass('active');
					reSort($main, options);
				});
			});
		}

		function reSort($main, options) {
			var gameIds = applySelectedSortOrder(combinedResults, $main);
			if (options.gamesPerPage !== 0) {
				$main.scrollerStop();
			}
			$main.populate(gameIds, options);
			if (options.gamesPerPage !== 0) {
				$main.scroller({direction: 'left', auto: false});
			}
		}

		/**
		 *
		 * @param {Object} $group current filter group
		 * @returns {Function} lookup function for grep to filter out allowed games from other filter groups
		 */
		function getAllowedLookupForFilterGroup($group) {
			var groupId = $group.attr('id');

			// get all results except for this group itself
			var allowedInOtherGroups = $.extend({}, allResults);
			delete allowedInOtherGroups[groupId];

			var otherGroupIds = Object.keys(allowedInOtherGroups);

			if (otherGroupIds.length === 0) {
				return function () {
					return true;
				};
			}

			var lookup = {};

			$.each(allowedInOtherGroups[otherGroupIds[0]], function (undefined, gameId) {
				if (otherGroupIds.length === 1) {
					lookup[gameId] = true;
				} else {
					for (var i = 1; i < otherGroupIds.length; i++) {
						if ($.inArray(gameId, allowedInOtherGroups[otherGroupIds[i]]) === -1) {
							return;
						}
					}
					lookup[gameId] = true;
				}
			});

			return function (gameId) {
				return lookup[gameId] !== undefined;
			};
		}

		function updateRemainingNumbers() {
			var $allGames = $('#casino-allgames');

			var $filterGroups = $allGames.find('.cnt-filter');
			$filterGroups.each(function () {
				var $group = $(this);
				var activeGroup = $group.hasClass('active');
				var allowedLookupForGroup =
					getAllowedLookupForFilterGroup($group);

				$group.find('li[data-games]').each(function () {
					var $filter = $(this);

					var gameIds = $.grep($filter.data('games'), function (gameId) {
						return casino.getMatchingGame(gameId) !== undefined;
					});

					var filtered;

					if (activeGroup && !$filter.hasClass('active')) {
						filtered = $.grep(gameIds, allowedLookupForGroup);
					} else {
						if (Object.keys(allResults).length === 0) {
							filtered = gameIds;
						} else {
							filtered = $.grep(gameIds, function (gameId) {
								if (gameId.slice(0, 5) === 'group') {
									var group = casino.getGame(gameId);
									var groupGames = Object.keys(group.games);

									for (var j = 0; j < groupGames.length; j++) {
										if ($.inArray(groupGames[j].slice(5), combinedResults) > -1) {
											return true;
										}
									}
								}
								return $.inArray(gameId, combinedResults) > -1;
							});
						}
					}
					var count = filtered.length;
					$filter.find('.count span').text(count);
				});

			});
		}

		function update($main, options) {
			var gameIds = applySelectedSortOrder(combineAllFilters($main), $main);
			if (options.gamesPerPage !== 0) {
				$main.scrollerStop();
			}
			$main.populate(gameIds, options);
			if (options.gamesPerPage !== 0) {
				$main.scroller({auto: false, direction: 'left'});
			}
			$main.find('#rightcolumn h1:first').applyTemplate({count: combinedResults.length, total: Object.keys(casinoData.games).length});
			currentCount = combinedResults.length;
			updateRemainingNumbers();
		}

		var initialPopulateTimeout;

		function initialPopulate($main, options) {
			combinedResults = $main.find('#sort-games a:first').data('order');
			if (combinedResults === 'undefined' || $main.length === 0) {
				clearTimeout(initialPopulateTimeout);
				initialPopulateTimeout = setTimeout(initialPopulate($main, options), 200);
			}
			$main.populate(combinedResults, options);
			var total = casinoData.games ? Object.keys(casinoData.games).length : 0;
			$main.find('#rightcolumn h1:first').applyTemplate({count: combinedResults.length, total: total});
			currentCount = combinedResults.length;
			updateRemainingNumbers();
		}

		function setup($main, options) {
			var $filters = $main.find('.cnt-filter');
			initialPopulate($main, options);
			setupFilters($filters, $main, options);
			setupSort($main, options);
			setupShowAll($filters, $main, options);
			setupStartLinks($main);
		}

		function hideEmptyGameProviders() {
			$('.cnt-filter.providers').find('li[data-games="[]"]').hide();
		}

		function getCurrentCount() {
			return currentCount;
		}


		function checkIfWeAreOnTheAllGamesPage() {
			return ($('#casino-allgames-submenu').hasClass('active'));

		}

		function clickShowAll($main) {
			var $filters = $main.find('.cnt-filter');
			$filters.find('a:first').click();
		}

		function checkIfAnyGameProviderIsSelected() {
			return $filterProviders.hasClass('active');
		}

		function checkIfGameOsIsSelected() {
			return $playtechGameProvider.hasClass('active');
		}

		function isTopMenuLiveCasinoSelected() {
			return $('#livecasinotab').hasClass('active');
		}

		var firstTimeClickedOfLiveCasinoFilter = false;

		function clickLiveCasinoFilterOnLiveCasinoTab() {
			if (isTopMenuLiveCasinoSelected() && !allgames.checkIfGameOsIsSelected()) {
				var $allGamesFilter = $('#casino-allgames').find('.cnt-filter');
				var $liveCasino = $allGamesFilter.find('#livecasino');
				if (!$liveCasino.hasClass('active') && firstTimeClickedOfLiveCasinoFilter === false) {
					$liveCasino.click();
					firstTimeClickedOfLiveCasinoFilter = true;
				}
			}
		}

		function updateGameProviders(providers) {
			var hashWithoutGameProviders = getHashWithoutGameProviders();
			if (providers.length > 0) {
				location.hash = hashWithoutGameProviders + '/' + providers.join(',');
			} else {
				location.hash = hashWithoutGameProviders;
			}
		}

		function getHashWithoutGameProviders() {
			var hash = location.hash;
			var indexOf = hash.lastIndexOf('/');
			if (indexOf > -1) {
				return hash.substr(0, indexOf);
			} else {
				return hash;
			}
		}

		function getGameProvidersExtractedFromHash() {
			var hash = location.hash;
			var indexOf = hash.indexOf('/');
			if (indexOf > -1) {
				return hash.substr(indexOf + 1).split(',');
			}
			return [];
		}

		function checkIfNecessaryToReloadLobbyAfterHashChanged() {
			return isNecessaryToReloadLobbyAfterHashChanged;
		}

		var allgames = {
			initialized: false,
			init: function () {
				$(function () {
					if (allgames.initialized) {
						return;
					}
					allgames.initialized = true;
					hideEmptyGameProviders();
					setup($('#casino-allgames'), {});
				});

			},
			setup: setup,
			currentCount: getCurrentCount,
			checkIfGameOsIsSelected: checkIfGameOsIsSelected,
			clickLiveCasinoFilterOnLiveCasinoTab: clickLiveCasinoFilterOnLiveCasinoTab,
			checkIfAnyGameProviderIsSelected: checkIfAnyGameProviderIsSelected,
			checkIfNecessaryToReloadLobbyAfterHashChanged: checkIfNecessaryToReloadLobbyAfterHashChanged,
			getGameProvidersExtractedFromHash: getGameProvidersExtractedFromHash,
			getHashWithoutGameProviders: getHashWithoutGameProviders
		};

		return allgames;
	}
)
;


